import client from './client';

/**
 * Get all details for a round
 */
export const getDetails = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/details`);
  return response.data;
};

/**
 * Add a new detail (starts debounce period)
 */
export const addDetail = async (gameId, roundId, content) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/details`, { content });
  return response.data;
};

/**
 * Confirm a detail after debounce period
 */
export const confirmDetail = async (gameId, roundId, detailId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/details/${detailId}/confirm`);
  return response.data;
};

/**
 * Cancel a detail during debounce period
 */
export const cancelDetail = async (gameId, roundId, detailId) => {
  const response = await client.delete(`/api/games/${gameId}/rounds/${roundId}/details/${detailId}`);
  return response.data;
};

/**
 * Support (bid on) a detail
 */
export const supportDetail = async (gameId, roundId, detailId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/details/${detailId}/support`);
  return response.data;
};

/**
 * Get rejection status
 */
export const getRejectionStatus = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/details/rejection`);
  return response.data;
};

/**
 * Toggle GM rejection
 */
export const toggleRejection = async (gameId, roundId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/details/rejection/toggle`);
  return response.data;
};
